module.exports = __webpack_public_path__ + "7d088296/img/pdf-icon.79f04a36.svg";